import * as jsxRuntime from "/var/lib/jenkins/workspace/WebGIS-Production/WebGIS-Webapp-Production/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment